import React, { useState, useEffect } from "react";
import "../styles/Dashboard.scss";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { getUserPlanInfoService } from "../services";
import { getPlanPermissions } from "../helper";

export const PlanContext = React.createContext(null);

const DashboardLayout = ({ children, hideBreadcrumb }) => {
    const [collapsed, setCollapsed] = useState(true);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [planInfo, setPlanInfo] = useState(null);
    const [planLoading, setPlanLoading] = useState(true);

    useEffect(() => {
        document.body.style.overflow = mobileOpen ? "hidden" : "auto";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [mobileOpen]);

    // Fetch user plan info — must be called first before any other API
    useEffect(() => {
        const fetchPlanInfo = async () => {
            try {
                const response = await getUserPlanInfoService();
                const data = response?.statusCode?.response_data?.data?.plan_info || {};
                if (data) {
                    setPlanInfo(data);
                }
            } catch (error) {
                console.error('Error fetching plan info:', error);
            } finally {
                setPlanLoading(false);
            }
        };
        fetchPlanInfo();
    }, []);

    const handleToggle = () => {
        if (window.innerWidth <= 768) {
            setMobileOpen(!mobileOpen);
        } else {
            setCollapsed(!collapsed);
        }
    };

    const handleCloseMobile = () => {
        if (mobileOpen) setMobileOpen(false);
    };

    const isExpired = planInfo?.is_expired === true;

    const handleRenewPlan = async () => {
        try {
            const emailId = localStorage.getItem('email') || '';
            await fetch('https://api.nmtsecurity.com/nmt/web/api/v1/create-lead', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: '',
                    emailId: emailId,
                    phoneNumber: '',
                    address: '',
                    description: 'Plan expired - user clicked Renew Plan',
                    lead_type: 'contact'
                })
            });
        } catch (error) {
            console.error('Error creating lead:', error);
        }
    };

    return (
        <div className={`gridContainer ${collapsed ? "collapsed" : ""}`}>
            <header className="headerWrapper">
                <Header collapsed={collapsed} planInfo={planInfo} onToggle={handleToggle} hideBreadcrumb={hideBreadcrumb} />
            </header>

            {mobileOpen && <div className="backdrop" onClick={handleCloseMobile} />}

            <aside className={`sidebarWrapper ${mobileOpen ? "open" : ""}`}>
                <Sidebar
                    collapsed={collapsed}
                    isMobileOpen={mobileOpen}
                    onClose={handleCloseMobile}
                    onToggle={handleToggle}
                    planInfo={planInfo}
                />
            </aside>

            <PlanContext.Provider value={{ planInfo, permissions: getPlanPermissions(planInfo) }}>
                <main className="mainWrapper">
                    {!planLoading && !isExpired && children}
                </main>
            </PlanContext.Provider>

            {/* Plan Expired Full-Screen Overlay */}
            {!planLoading && isExpired && (
                <div className="plan_expired_overlay">
                    <div className="plan_expired_card">
                        {/* <div className="plan_expired_icon">
                            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="#FF4D4F" strokeWidth="1.5" />
                                <path d="M12 7V13" stroke="#FF4D4F" strokeWidth="2" strokeLinecap="round" />
                                <circle cx="12" cy="16.5" r="1" fill="#FF4D4F" />
                            </svg>
                        </div> */}
                        <h2 className="plan_expired_title">Your Plan Has Expired</h2>
                        <p className="plan_expired_desc">
                            Your subscription has ended. Please renew your plan to continue accessing all features.
                        </p>
                        <button
                            className="plan_expired_btn"
                            onClick={handleRenewPlan}
                        >
                            Renew Plan
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardLayout;
